// extracted by mini-css-extract-plugin
export default {"swap":"Swap_swap__vWTPn"};